export const fontWeights = {
  body: 400,
  heading: 500,
  regular: 400,
  medium: 500,
};
